// // src/AppLayout.js
// import React from "react";
// import { Outlet } from "react-router-dom";
// import AppToolbar from "./components/AppToolbar";

// const AppLayout = () => {
//   return (
//     <div>
//       <AppToolbar />
//       <div style={{ padding: "20px" }}>
//         <Outlet />
//       </div>
//     </div>
//   );
// };

// export default AppLayout;

import React from "react";
import { AppBar, Toolbar, Typography, Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import AppToolbar from "./components/AppToolbar";
import Slider from "./components/Slider";
import { useLocation } from "react-router-dom";
import Footer from "./components/Footer";

const AppLayout = () => {

  const location = useLocation();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* AppBar */}
      <AppToolbar />
      {location.pathname === "/" && <Slider />}
   
      {/* Main Content */}
      <Container sx={{ flex: 1, marginTop: 2 }}>
        <Outlet /> {/* This renders the content of the active route */}
      </Container>

      {/* Footer */}
      <Footer />
      {/* <Box component="footer" sx={{ backgroundColor: "#f5f5f5", padding: 2, marginTop: 2 }}>
        <Typography variant="body2" align="center" color="text.secondary">
          © {new Date().getFullYear()} Freshsweeper Cleaning Service, Inc. All rights reserved.
        </Typography>
      </Box> */}
    </Box>
  );
};

export default AppLayout;